<template>
  <b-table-simple
    responsive
    hover
    class="compact-table"
  >
    <b-tbody>
      <b-tr>
        <b-th>
          Invoice No.
        </b-th>
        <b-td>
          {{ item.invoice_number }}
        </b-td>
        <b-th>
          Date
        </b-th>
        <b-td>
          {{ formatedDate(item.invoice_date) }}
        </b-td>
      </b-tr>
      <b-tr>
        <b-th>
          Purchase Bill Number
        </b-th>
        <b-td>
          {{ item.purchase_bill_number }}
        </b-td>
        <b-th>
          Total Items
        </b-th>
        <b-td>
          {{ item.items.length }}
        </b-td>
      </b-tr>
      <b-tr>
        <b-th>
          Approved By
        </b-th>
        <b-td>
          {{ item.approved_by_name }}
        </b-td>
        <b-th>
          Approved Date
        </b-th>
        <b-td>
          {{ item.approval_date && formatedDate(item.approval_date) }}
        </b-td>
      </b-tr>
      <b-tr>
        <b-th>
          CSV File
        </b-th>
        <b-td>
          <a
            v-if="item.original_csv_file"
            :href="item.original_csv_file"
            target="_blank"
            class="my-50"
          >
            <span>View File</span>
          </a>
          <span v-else>-</span>
        </b-td>
        <b-th>
          Status
        </b-th>
        <b-td>
          <b-badge :variant="getStatusVariant(item.status)">
            {{ item.status.charAt(0).toUpperCase() + item.status.slice(1) }}
          </b-badge>
        </b-td>
      </b-tr>
      <b-tr>
        <b-th>
          CSV Recieved at
        </b-th>
        <b-td>
          {{ item.csv_recieved_at && formatedDate(item.csv_recieved_at, 'DD-MM-YYYY LT') }}
        </b-td>
        <b-th />
        <b-tr />
      </b-tr>
    </b-tbody>
  </b-table-simple>
</template>

<script>

import {
  BTableSimple, BTbody, BTd, BTr, BTh,
  BBadge,
} from 'bootstrap-vue'

import dateMixin from '@/mixins/dateMixin'
import formatMixin from '@/mixins/formatMixin'

export default {
  components: {
    BTableSimple,
    BTbody,
    BTd,
    BTr,
    BTh,
    BBadge,
  },
  mixins: [dateMixin, formatMixin],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  methods: {
    getStatusVariant(status) {
      switch (status?.toLowerCase()) {
        case 'approved':
          return 'success'
        case 'pending':
          return 'warning'
        case 'rejected':
          return 'danger'
        default:
          return 'secondary'
      }
    },
  },
}
</script>
